import { createGettext } from "vue3-gettext";

import { SurveyLanguage } from "../../../types/api-types";
import { i18nConfig } from "../config";
import translations from "./translations.json";

export const gettext = createGettext({
  availableLanguages: i18nConfig.availableLanguages,
  defaultLanguage: i18nConfig.defaultLanguage,
  translations: translations,
  silent: true,
  mutedLanguages: i18nConfig.mutedLanguages,
  sourceCodeLanguage: SurveyLanguage.De,
});
